import React, {useContext, useState} from "react"
import {Link} from "gatsby"
import MenuContext from "../MenuContext"
import {motion} from "framer-motion"
import {menuItems} from "./NavConstants"
import Socials from "../Socials/Socials"
import {UseSiteMetadata} from "../../hooks/useSiteMetadata"
import {
  NavModuleStyles,
  NavTopLevel,
  HamburgerStyles,
  LogoStyles,
} from "./NavModuleStyles"
import {
  barOneVariants,
  barTwoVariants,
  barThreeVariants,
  menuList,
} from "./NavAnim"
import {StaticImage} from "gatsby-plugin-image";

const NavModule = () => {

  const [isOpen, setNav] = useContext(MenuContext)
  const [subNavIsOpen, setSubNav] = useState(false)

  const toggleNav = () => {
    setNav((isOpen) => !isOpen)
  }

  const toggleSubNav = () => {
    setSubNav((subNavIsOpen) => !subNavIsOpen)
  }

  const siteMeta = UseSiteMetadata()

  return (
      <NavModuleStyles>
        <div className="nav">
          <div className="container">
            <HamburgerStyles
                initial="closed"
                animate={isOpen ? "open" : "closed"}
                onClick={toggleNav}
                // onKeyDown={toggleNav}
                aria-label={isOpen ? "Close Menu" : "Open Menu"}
                className={isOpen ? " open" : ""}
            >
              <motion.span
                  className="bar"
                  variants={barOneVariants}
              ></motion.span>
              <motion.span
                  className="bar"
                  variants={barTwoVariants}
              ></motion.span>
              <motion.span
                  className="bar"
                  variants={barThreeVariants}
              ></motion.span>
            </HamburgerStyles>

            {siteMeta.title && (
                <LogoStyles>
                  <Link to="/">
                    <StaticImage
                        className="nav__logo"
                        imgClassName="banner__image--content"
                        src="../../../static/logos/logo-yellow--small.png"
                        alt="A Vulgar Display Of Flour logo"
                        layout="constrained"
                        transformOptions={{grayscale: false, fit: "contain"}}
                        placeholder="blurred"
                    />
                  </Link>
                </LogoStyles>
            )}

            <Socials />
          </div>
        </div>
        <motion.div
            initial="closed"
            animate={isOpen ? "open" : "closed"}
            variants={menuList}
            transition={{type: "ease", stiffness: 50, velocity: 50}}
            className="menu"
        >
          <NavTopLevel>
            {menuItems.map((item, index) => (
                <li key={index}>
                  <Link
                      onClick={toggleNav}
                      // onKeyDown={toggleNav}
                      to={item.path}
                      activeClassName="menu__item--active"
                  >
                    {item.text}
                  </Link>
                </li>
            ))}
            <li className={"socials"}>
              <Socials/>
            </li>
          </NavTopLevel>
        </motion.div>
      </NavModuleStyles>
  )
}

export default NavModule
